import { props } from '@ngrx/store';
import { User } from '../models';

import { createActionGroup, emptyProps } from '@ngrx/store';

export const usersActions = createActionGroup({
    source: 'Users',
    events: {
        'Get Users': emptyProps(),
        'Get Users Success': props<{ users: User[] }>(),
        'Get Users Error': emptyProps(),
        Clear: emptyProps(),
    },
});
